import * as React from "react";

interface IViewAll {
  size?: string;
  color?: string;
  whiteBlueVariant?: boolean;
}

const Viewall = (props: IViewAll) => {
  const defaultValue = "41";
  const defaultColor = "#03002f";
  return (
    <>
      {props.whiteBlueVariant ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31"
          height="30"
          viewBox="0 0 31 30"
          fill="none"
        >
          <circle cx="15.5412" cy="15.0002" r="11.1818" fill="white" />
          <circle cx="15.541" cy="15" r="14.5" stroke="white" />
          <circle cx="15.542" cy="15" r="8.1123" fill="#03002F" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.5139 15.0001L14.5905 17.8503L14.0059 17.2803L16.3445 15.0001L14.0059 12.7199L14.5905 12.1498L17.5139 15.0001Z"
            fill="white"
          />
        </svg>
      ) : (
        <svg
          width={props.size ? props.size : defaultValue}
          height={props.size ? props.size : defaultValue}
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse
            cx="15.0002"
            cy="15.0002"
            rx="11.1818"
            ry="11.1818"
            fill={props.color ? props.color : defaultColor}
            fillOpacity="0.1"
          />
          <circle
            cx="15"
            cy="15"
            r="14.5"
            stroke={props.color ? props.color : defaultColor}
            strokeOpacity="0.05"
          />
          <ellipse
            cx="15.001"
            cy="15.0005"
            rx="8.1123"
            ry="8.1123"
            fill={props.color ? props.color : defaultColor}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.9729 14.9964L14.0495 17.8467L13.4648 17.2766L15.8035 14.9964L13.4648 12.7162L14.0495 12.1461L16.9729 14.9964Z"
            fill="white"
          />
        </svg>
      )}
    </>
  );
};

export default Viewall;
